<template>
  <section class="why-proxify-section">
    <div class="container">
      <div class="image-container">
        <NuxtPicture
          src="/images/roles/why-proxify/dev_with_phone.png"
          alt="hero"
          lazy
        />
      </div>
      <div class="section-right">
        <div class="section-content">
          <h1>Why Proxify?</h1>
          <p>
            Enjoy exclusive benefits, alongside 3000+ members of Europe’s
            largest tech talent network.
          </p>
          <NuxtPicture
            src="/images/roles/why-proxify/dev_with_phone.png"
            alt="hero"
            class="image-mobile"
            lazy
          >
            <source
              srcset="/images/roles/why-proxify/dev_with_phone.png"
              type="image/webp"
              media="(min-width: 576px)"
            />
            <source
              srcset="/images/roles/why-proxify/dev_with_phone_mobile.png"
              type="image/webp"
              media="(max-width: 575px)"
            />
            <img
              src="/images/roles/why-proxify/dev_with_phone_mobile.png"
              alt="hero"
              loading="lazy"
            />
          </NuxtPicture>
        </div>
        <div class="items-wrapper">
          <div
            v-for="(carouselItem, index) in carouselItems"
            :key="index"
            class="card"
          >
            <Item :item="carouselItem" />
          </div>
        </div>
        <div
          ref="itemsWrapper"
          class="items-wrapper-mobile"
        >
          <div
            ref="carousel"
            class="items"
            :style="`left:${dataItems.left}`"
          >
            <div
              v-for="(carouselItem, index) in carouselItems"
              :key="index"
              ref="itemRef"
              class="card"
            >
              <Item :item="carouselItem" />
            </div>
          </div>
          <div class="dots">
            <div
              v-for="(_, index) in carouselItems"
              :key="index"
              class="dot"
              :class="dataItems.index === index && 'active'"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-wrapper">
      <div class="container">
        <p class="logo-paragraph">
          We're honored to be recognized for our achievements as a remote,
          global company, and a leader in tech talent.
        </p>
        <span class="label">AWARDS:</span>
        <div class="logos">
          <NuxtImg
            v-for="(logo, index) in logos"
            :key="`${logo}-${index}`"
            :src="`/images/roles/why-proxify/${logo}`"
            :alt="logo"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Item from './Item/Item.vue';
import carousel from '~/mixins/carousel';

export default {
  components: { Item },
  mixins: [carousel],
  data() {
    return {
      carouselItems: [
        {
          icon: 'user_with_stars',
          title: 'Join the top 2%',
          description:
            'Showcase your skills and enter an exclusive tech talent network trusted by Fortune 500 companies.',
        },
        {
          icon: 'money',
          title: 'Trust and transparency',
          description:
            'Know your compensation and working hours in advance. No more nasty surprises.',
        },
        {
          icon: 'puzzle',
          title: 'Efficiency',
          description:
            'No more endless interviews. Enjoy a streamlined hiring process.',
        },
        {
          icon: 'globe',
          title: 'Networking',
          description:
            'Learn and grow alongside other ambitious, talented tech professionals.',
        },
      ],
      logos: ['gasell.svg', 'deel.svg', 'deloitte.png'],
    };
  },
  methods: {
    setActiveItem(direction, isMobile = false) {
      const currentIndex = this.dataItems.index;
      const itemWidth = this.$refs.itemRef[0].clientWidth;
      const carouselWidth = this.$refs.carousel.clientWidth;
      const itemsWrapperWidth = this.$refs.itemsWrapper.clientWidth;
      const lastIndex = this.carouselItems.length - (isMobile ? 1 : 2);
      const newIndex =
        direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      const increment = direction === 'next' ? -1 : 1;
      const leftValue = this.dataItems.value + increment * itemWidth;
      const pushToLastItemIndex = this.carouselItems.length - 3;
      const paddingMobile = 24;
      const offsetLeft = 345;

      if (newIndex < 0 || newIndex > lastIndex) {
        return;
      }

      if (!isMobile && direction === 'prev' && currentIndex === 1) {
        this.dataItems = {
          left: `${0}px`,
          value: 0,
          index: newIndex,
          transition: '0.6s',
        };
      } else if (
        !isMobile &&
        direction === 'next' &&
        currentIndex === pushToLastItemIndex &&
        carouselWidth > -leftValue
      ) {
        this.dataItems = {
          left: `${itemsWrapperWidth - carouselWidth + offsetLeft}px`,
          value: itemsWrapperWidth - carouselWidth + offsetLeft,
          index: newIndex,
          transition: '0.6s',
        };
      } else {
        this.dataItems = {
          left: `${
            leftValue -
            (direction === 'next' ? paddingMobile : -increment * paddingMobile)
          }px`,
          value:
            leftValue -
            (direction === 'next' ? paddingMobile : -increment * paddingMobile),
          index: newIndex,
          transition: '0.6s',
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './WhyProxify.scss';
</style>
